import React, { useState } from 'react';

import PropTypes from 'prop-types';
import { Form } from 'react-final-form';
import { connect } from 'react-redux';

import { Button } from 'components';
import ProgressBar from 'components/ProgressBar/ProgressBar';
import BusinessCategoriesField from 'containers/BusinessCategoriesField/BusinessCategoriesField';
// import AdditionalLocationsFieldGroup from 'containers/LocationFieldGroup/AdditionalLocationsFieldGroup/AdditionalLocationsFieldGroup';
import BusinessLogosFieldGroup from 'containers/BusinessLogosFieldGroup/BusinessLogosFieldGroup';
import { actions } from 'coupon-common/src/modules/businessInfo';
import { dispatchAsAsync } from 'coupon-common/src/utils';

import styles from './Step3_ProfileSettings.module.scss';

const Step3_ProfileSettings = ({
  initialValues,
  onBack,
  onNext,
  onSkip,
  currentStep,
  totalSteps,
  dispatch,
  businessInfo,
}) => {
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const onSubmit = async values => {
    setLoading(true);
    setErrorMessage('');

    try {
      const submitErrors = await dispatchAsAsync(
        actions.updateInfo(values),
        dispatch,
      );

      if (submitErrors) {
        setErrorMessage(
          submitErrors.message || 'Something went wrong. Please try again.',
        );
      } else {
        onNext({ ...values, hideBackButton: true });
      }
    } catch (err) {
      setErrorMessage('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
    // onNext({ ...values, hideBackButton: true });
  };

  return (
    <div className={styles.formContainer}>
      <ProgressBar
        currentStep={currentStep}
        totalSteps={totalSteps}
        label="Profile Settings"
      />

      <Form
        onSubmit={onSubmit}
        initialValues={businessInfo}
        render={({ handleSubmit }) => (
          <form onSubmit={handleSubmit}>
            <div className={styles.uploadSection}>
              <BusinessLogosFieldGroup />
            </div>

            <BusinessCategoriesField />
            {/* <AdditionalLocationsFieldGroup /> */}

            {errorMessage && (
              <div style={{ color: 'red', margin: '5px', fontSize: '11px' }}>
                {errorMessage}
              </div>
            )}

            <div className={styles.buttonWrapper}>
              <Button
                type="button"
                outline
                onClick={onSkip}
                variant="link"
                disabled={loading}
              >
                Skip for now
              </Button>
              <Button type="submit" fetching={loading} disabled={loading}>
                Save & Continue
              </Button>
            </div>
          </form>
        )}
      />
    </div>
  );
};

Step3_ProfileSettings.propTypes = {
  initialValues: PropTypes.object,
  onBack: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired,
  onSkip: PropTypes.func.isRequired,
  currentStep: PropTypes.number.isRequired,
  totalSteps: PropTypes.number.isRequired,
  dispatch: PropTypes.func,
  businessInfo: PropTypes.object,
};

const mapStateToProps = state => ({
  businessInfo: state.businessInfo.data,
});

export default connect(mapStateToProps)(Step3_ProfileSettings);
